/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ComponentProps, ReactElement } from 'react';
import { cssMap } from '@compiled/react';

import { jsx } from '@atlaskit/css';
import type { DecisionItem as OriginalDecisionItem } from '@atlaskit/renderer/nodes';
import { token } from '@atlaskit/tokens';

import type { LightNodeProps } from '../LightNodeObserver.ts';

const styles = cssMap({
	item: {
		display: 'flex',
		flexDirection: 'row',
		position: 'relative',
		marginTop: token('space.100'),
		paddingBlock: token('space.100'),
		paddingRight: token('space.100'),
		paddingLeft: token('space.150'),
		borderRadius: token('radius.small'),
		backgroundColor: token('color.background.neutral'),
	},
	icon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexBasis: '16px',
		flexGrow: 0,
		flexShrink: 0,
		width: '16px',
		height: '16px',
		marginTop: token('space.050'),
		marginRight: token('space.150'),
		backgroundColor: token('color.background.neutral.bold'),
		borderRadius: token('radius.full'),
	},
	content: {
		flexBasis: 'auto',
		flexGrow: 1,
		flexShrink: 1,
		minWidth: 0,
		wordWrap: 'break-word',
	},
});

export const DecisionItem = ({
	children,
	dataAttributes,
	lightNodeRef,
}: Pick<ComponentProps<typeof OriginalDecisionItem>, 'children' | 'dataAttributes'> &
	LightNodeProps): ReactElement => (
	<div ref={lightNodeRef} css={styles.item} data-decision-wrapper="true">
		<span
			aria-hidden="true"
			css={styles.icon}
			contentEditable={false}
			data-decision-icon-placeholder
		/>
		<div {...dataAttributes} css={styles.content} data-component="content">
			{children}
		</div>
	</div>
);
